import type { LocationBootstrapMeter } from '@/features/location-bootstrap/location-bootstrap-types';
import type { GeoPoint } from '@/routers/inventorization/components/position/GoogleMarkerMapPicker';

export const DEFAULT_GPS_POINT: GeoPoint = {
  lat: 49.189,
  lng: 16.617,
};

export function readMeterGeoPoint(meter: LocationBootstrapMeter): GeoPoint | null {
  const point = readGpsPoint({
    lat: meter.gpsLat,
    lng: meter.gpsLng,
  });

  return point ? { ...point, key: String(meter.id) } : null;
}

export function readGeoPoint(value: unknown): GeoPoint | null {
  if (!value || typeof value !== 'object') {
    return null;
  }

  const record = value as { lat?: unknown; lng?: unknown };
  const lat = readCoordinate(record.lat);
  const lng = readCoordinate(record.lng);

  if (lat === null || lng === null) {
    return null;
  }

  if (lat === 0 && lng === 0) {
    return null;
  }

  return { lat, lng };
}

function readGpsPoint(value: { lat: unknown; lng: unknown }): GeoPoint | null {
  const lat = readCoordinate(value.lat);
  const lng = readCoordinate(value.lng);

  if (lat === null || lng === null) {
    return null;
  }

  if (lat === 0 && lng === 0) {
    return null;
  }

  return { lat, lng };
}

function readCoordinate(value: unknown) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim()) {
    const parsed = Number(value);

    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}
